import { xCheck } from './xCheck';
import { xPadding } from './xPadding';
/**
 * This function calculates a rolling average
 *
 * @param array - array
 * @param fct - callback function that from an array returns a value
 * @param options - options
 */
export function xRolling(array, fct, options = {}) {
    xCheck(array);
    if (typeof fct !== 'function')
        throw Error('fct has to be a function');
    const { window = 5, padding = {} } = options;
    const { size = window - 1, algorithm, value } = padding;
    array = xPadding(array, { size, algorithm, value }); // ensure we get a copy and it is float64
    const newArray = [];
    for (let i = 0; i < array.length - window + 1; i++) {
        // we will send a view to the original buffer
        newArray.push(fct(array.subarray(i, i + window)));
    }
    return newArray;
}
//# sourceMappingURL=xRolling.js.map